import React from 'react'

function SettingBilling() {
  return (
    <div className="setting-block">SettingBilling</div>
  )
}

export default SettingBilling